import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
    modelValue: { type: Boolean },
    header: null,
    message: null,
    acceptLabel: null,
    rejectLabel: null
  },
  emits: ["update:modelValue", "accept", "reject"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:modelValue', value: boolean): void;
  (e: 'accept'): void;
  (e: 'reject'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: boolean;
  header: string;
  message?: string;
  acceptLabel?: string;
  rejectLabel?: string;
}





const isDialog = computed({
  get: () => props.modelValue,
  set: value => emits('update:modelValue', value),
});

const onCloseDialog = () => {
  isDialog.value = false;
  emits('update:modelValue', false);
};
const onAccept = () => {
  emits('accept');
  onCloseDialog();
};
const onReject = () => {
  emits('reject');
  onCloseDialog();
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _unref(isDialog),
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isDialog) ? (isDialog).value = $event : null)),
    modal: true,
    dismissableMask: "",
    draggable: false,
    "close-on-escape": "",
    header: __props.header,
    onHide: _cache[1] || (_cache[1] = ($event: any) => (emits('update:modelValue', false))),
    class: "p-confirm-dialog"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: __props.rejectLabel || _ctx.$t('cancel'),
        onClick: onReject,
        class: "button-base"
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        label: __props.acceptLabel || _ctx.$t('confirm'),
        onClick: onAccept,
        class: "button-primary"
      }, null, 8, ["label"])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["visible", "header"]))
}
}

})